<div class="loader-wrapper" [style.height.px]="loaderHeight" *ngIf="isLoading">
    <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
    </div>
</div>

<ng-content *ngIf="!isLoading"></ng-content>
